var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('b-card',[_vm._v(" 404 NOT FOUND !! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }